import { render, staticRenderFns } from "./RssStyle.vue?vue&type=template&id=38f27b84&"
import script from "./RssStyle.vue?vue&type=script&lang=ts&"
export * from "./RssStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports